export class SetWeek {
    public static readonly type = '[JobsPlacements] Set shift week';

    constructor(public week: Date) { }
}
